module.exports = __webpack_public_path__ + "img/img15.4ba63e66.svg";